import React, { FC } from 'react';

import { Grid } from '@chakra-ui/react';

import { MetadataCommonFields } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/Components/MetadataCommonFields';
import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';

import {
  BedrockCustomModelBaseModelARN,
  BedrockCustomModelBaseModelName,
  BedrockCustomModelDeploymentARNs,
  BedrockCustomModelDeploymentNames,
  BedrockCustomModelDeploymentStatuses,
  BedrockCustomModelOutputDataBucket,
  BedrockCustomModelOwnerAccountID,
  BedrockCustomModelTrainingDataBucket,
  BedrockModelARN,
  BedrockModelKMSKeyARN,
} from '../../../../Components/MetadataField/MetaGridFields';

export const AWSBedrockCustomModelMetadata: FC = () => {
  const { resourceDetails, resourceInsight } = useActiveResourceContext();
  const { data: resource } = resourceDetails;
  const { data: insight } = resourceInsight;
  const metadata = { ...resource, ...insight };

  return (
    <Grid templateColumns="repeat(4, 1fr)" gap={4}>
      <MetadataCommonFields
        state="None"
        availabilityZone="None"
        vpc="None"
        owner="None"
        createdAt={metadata}
      />
      {BedrockCustomModelTrainingDataBucket(metadata)}
      {BedrockCustomModelOutputDataBucket(metadata)}
      {BedrockCustomModelDeploymentARNs(metadata)}
      {BedrockCustomModelDeploymentNames(metadata)}
      {BedrockCustomModelDeploymentStatuses(metadata)}
      {BedrockModelARN(metadata)}
      {BedrockCustomModelBaseModelARN(metadata)}
      {BedrockCustomModelBaseModelName(metadata)}
      {BedrockCustomModelOwnerAccountID(metadata)}
      {BedrockModelKMSKeyARN(metadata)}
    </Grid>
  );
};
